import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeStatus: {
    name: 'All',
    id: 'all',
    active: true,
  },
  searchValue: '',
  statuses: null,
  list: [],
  currentPage: 1,
  activeJob: {},
  jobFormData: null,
  jobForms: {},
  justRescheduled: false
};

const jobsSlice = createSlice({
  name: "techbsook",
  initialState,
  reducers: {
    setJobStatuses(state, action) {
      state.statuses = action?.payload;
    },
    setJustRescheduled(state, action) {
      state.justRescheduled = action?.payload;
    },
    setJobForms(state, action) {
      state.jobForms = action?.payload
    },
    setSearchValue(state, action) {
      state.searchValue = action?.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action?.payload;
    },
    setCurrentPage2(state, action) {
      state.currentPage = action?.payload;
    },
    setActiveJobStatus(state, action) {
      if (state.activeStatus?.id === action?.payload?.id) {
        state.activeStatus = {
          name: 'All',
          id: 'all',
          active: true,
        };
      } else {
        state.activeStatus = action?.payload;
      }
    },
    setList(state, action) {
      state.list = action?.payload;
    },
    setActiveJob(state, action) {
      state.activeJob = action?.payload;
    },
    setJobForm(state, action) {
      state.jobFormData = action?.payload;
    }
  },
});

export const { setJobStatuses,
  setActiveJobStatus,
  setList,
  setSearchValue,
  setCurrentPage,
  setActiveJob,
  setJobForm,
  setJobForms,
  setCurrentPage2,
  setJustRescheduled
} =
  jobsSlice.actions;

export default jobsSlice.reducer;
